import { uiSize } from '@utils'

interface Props {
  color?: string
  variant?: 'default' | 'compact'
}

function CopyIcon({ color = 'var(--text-primary)', variant = 'default' }: Props) {
  if (variant === 'compact') {
    return (
      <svg viewBox='0 0 24 24' fill='none' stroke={color} strokeWidth='2'>
        <rect x='9' y='9' width='13' height='13' rx='2' />
        <path d='M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1' />
      </svg>
    )
  }

  return (
    <svg width={uiSize(17)} height={uiSize(22)} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17 22' fill='none'>
      <rect
        x='0.607265'
        y='4.05014'
        width='12.5002'
        height='16.4323'
        rx='1.82143'
        stroke={color}
        strokeWidth='1.21429'
      />
      <path
        d='M5.71436 1.0896L13.3288 1.0896C14.8041 1.0896 16.0002 2.28564 16.0002 3.76103V14.6186'
        stroke={color}
        strokeWidth='1.21429'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default CopyIcon
